import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const accountManagementAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.ApprovalsManagementAdmin],
    permissions: [Permission.ApprovalsManagementView],
  },
]
